import { LoadedPriceFilterProps } from '../PriceFilter';
import { BestItineraryData } from 'clientState/providers/FilteredItinerariesProvider/createBestItineraryData';

const PriceCollector = () => {
  return {
    build(maxItinerary?: BestItineraryData): LoadedPriceFilterProps {
      return {
        minPrice: {
          amount: 0,
          currency: maxItinerary?.itinerary?.price.currency || '',
        },
        maxPrice: {
          amount: Math.ceil(maxItinerary?.itinerary?.price.amount || Infinity),
          currency: maxItinerary?.itinerary?.price.currency || '',
        },
      };
    },
  };
};

export default PriceCollector;
